import { LinkProps } from 'ui/components/3-organisms/LinkList/LinkList';
import styles from './OrganisationCard.module.scss';
import { UI_Picture } from 'ui/components/1-atoms/Media/Picture/Picture';
import { UI_Heading } from 'ui/components/1-atoms/Heading/Heading';
import { UI_RichText } from 'ui/components/1-atoms/RichText/RichText';
import { UI_Paragraph } from 'ui/components/1-atoms/Paragraph/Paragraph';
import classNames from 'classnames';
import { UI_LinkWithIcon } from 'ui/components/1-atoms/Action/LinkWithIcon/LinkWithIcon';
import IconArrow from 'ui/icons/icon_right_arrow.svg';

export interface OrganisationCardProps {
	className?: string;
	logo?: { url: string; altText: string };
	heading: string;
	text: string;
	phone: string;
	email: string;
	link: LinkProps;
}
export const UI_OrganisationCard = ({ className, logo, heading, text, phone, email, link }: OrganisationCardProps) => {
	return (
		<div className={classNames(styles.OrganisationCard, className)}>
			{logo?.url && (
				<div className={styles.OrganisationCard_imageWrapper}>
					<UI_Picture url={logo.url} altText={logo.altText} imageCropping="contain" />
				</div>
			)}
			<UI_Heading
				className={classNames(styles.OrganisationCard_heading, { [styles.OrganisationCard_heading___noImage]: !logo?.url })}
				style="none"
			>
				{heading}
			</UI_Heading>
			{text && <UI_RichText className={styles.OrganisationCard_text} content={text} />}
			{(phone || email) && (
				<div className={styles.OrganisationCard_details}>
					{phone && <UI_Paragraph className={styles.OrganisationCard_phone}>{phone}</UI_Paragraph>}
					{email && <UI_Paragraph className={styles.OrganisationCard_email}>{email}</UI_Paragraph>}
				</div>
			)}
			{link && (
				<div className={styles.OrganisationCard_link}>
					<UI_LinkWithIcon
						url={link.url}
						target={link.target}
						icon={
							<span className={styles.OrganisationCard_linkIcon}>
								<IconArrow />
							</span>
						}
						text={link.name}
					/>
				</div>
			)}
		</div>
	);
};
